module.exports = __webpack_public_path__ + "media/images/cbs/server-74cbe7727cd4aec479eeb3a0e8d238e1.svg";